const MenuHead = ({ label }) => {
    return (
        <li className="menu-header small">
            <span className="menu-header-text">{label}</span>
        </li>
    );
};

export default MenuHead;
